import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Users, UserCheck, FileText, CheckSquare, DollarSign, Truck } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Dashboard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    clients: 0,
    employees: 0,
    contracts: 0,
    tasks: 0,
    monthly_revenue: 0,
    total_vehicles: 0
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const res = await axios.get(`${API}/stats/dashboard`);
      setStats(res.data);
    } catch (error) {
      console.error('Failed to fetch stats:', error);
    }
  };

  const statCards = [
    { icon: Users, label: 'Общо клиенти', value: stats.clients, color: '#3b82f6', route: '/clients' },
    { icon: UserCheck, label: 'Общо служители', value: stats.employees, color: '#8b5cf6', route: '/employees' },
    { icon: Truck, label: 'Общо превозни средства', value: stats.total_vehicles, color: '#06b6d4', route: '/clients' },
    { icon: FileText, label: 'Общо договори', value: stats.contracts, color: '#10b981', route: '/contracts' },
    { icon: CheckSquare, label: 'Общо задачи', value: stats.tasks, color: '#f59e0b', route: '/tasks' },
    { icon: DollarSign, label: 'Месечни приходи', value: `${stats.monthly_revenue.toFixed(2)} лв`, color: '#ef4444', route: '/finances' }
  ];

  return (
    <div className="dashboard" data-testid="dashboard-page">
      <h1 className="page-title">{t('dashboard')}</h1>

      <div className="stats-grid">
        {statCards.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div 
              key={index} 
              className="stat-card stat-card-clickable" 
              data-testid={`stat-card-${index}`}
              onClick={() => navigate(stat.route)}
            >
              <div className="stat-icon" style={{ backgroundColor: `${stat.color}20`, color: stat.color }}>
                <Icon size={32} />
              </div>
              <div className="stat-content">
                <div className="stat-label">{stat.label}</div>
                <div className="stat-value">{stat.value}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Dashboard;
